var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24 Emoji/Flags") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24-Emoji/Flags",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.458333333,-0.75 C0.838029099,-0.75 1.15182429,-0.467846118 1.20148672,-0.101770557 L1.20833333,0 L1.20833333,20.625 C1.20833333,21.0392136 0.872546896,21.375 0.458333333,21.375 C0.0786375678,21.375 -0.235157628,21.0928461 -0.284820051,20.7267706 L-0.291666667,20.625 L-0.291666667,0 C-0.291666667,-0.414213562 0.044119771,-0.75 0.458333333,-0.75 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3966324,0.625 C20.9623041,0.625603094 21.4750351,0.957903189 21.7066165,1.473999 C21.9171451,1.94317701 21.8597339,2.48494897 21.5650253,2.89773292 L21.4695245,3.01749688 L17.7982717,7.14433333 C17.610968,7.35487809 17.5901565,7.66043107 17.7361719,7.89246541 L17.7987483,7.97570294 L21.4653824,12.1052496 C21.8409889,12.5282207 21.9336146,13.1321552 21.7020332,13.648251 C21.4897502,14.1213388 21.0412235,14.4399872 20.5316165,14.4902745 L20.39125,14.49725 L0.458333333,14.49725 C0.044119771,14.49725 -0.291666667,14.1614636 -0.291666667,13.74725 C-0.291666667,13.3675542 -0.00951278505,13.053759 0.356562776,13.0040966 L0.458333333,12.99725 L20.251,12.997 L16.6775616,8.97216667 C16.0009271,8.21157375 15.9633363,7.08631251 16.5647869,6.28520352 L16.6775589,6.14733645 L20.255,2.125 L0.458333333,2.125 C0.0786375678,2.125 -0.235157628,1.84284612 -0.284820051,1.47677056 L-0.291666667,1.375 C-0.291666667,0.995304234 -0.00951278505,0.681509039 0.356562776,0.631846616 L0.458333333,0.625 L20.3966324,0.625 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlags);
export default __webpack_public_path__ + "static/media/flags.f836dbe0983fcd19282df377f34ba636.svg";
export { ForwardRef as ReactComponent };